// @flow
import { createReducer } from 'redux-act';

import type { IDNLanguages, IDNLanguages as State } from '../../types';
import { setLanguages } from '../actions/idn';

const initialState: State = [];

const setLanguagesHandler = (state: State, languages: IDNLanguages): State =>
  languages;

export default (createReducer(
  {
    [setLanguages.toString()]: setLanguagesHandler,
  },
  initialState,
): {
  (): (state: State, payload?: mixed, meta?: mixed) => State,
  assignAll: ({ ... } | Array<mixed>, { ... } | Array<mixed>) => mixed,
  batch: ({ ... } | Array<mixed>) => mixed,
  bindAll: ({ ... } | Array<mixed>, { ... } | Array<mixed>) => mixed,
  disbatch: (mixed, void | Array<mixed>) => mixed,
  has: (actionCreator: mixed) => boolean,
  // $FlowFixMe[cannot-resolve-name]
  off: Reducer$Off,
  // $FlowFixMe[cannot-resolve-name]
  on: Reducer$On<State>,
  options: () => mixed,
  ...
});
